import React from 'react';
import { motion } from 'framer-motion';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
  background?: 'default' | 'white' | 'primary' | 'dark';
}
export function Section({
  children,
  className = '',
  id,
  background = 'default'
}: SectionProps) {
  const bgStyles = {
    default: 'bg-[#faf8f5]',
    white: 'bg-white',
    primary: 'bg-[#2d5016] text-white',
    dark: 'bg-[#2c2c2c] text-white'
  };
  return <section id={id} className={`py-16 md:py-24 px-4 sm:px-6 lg:px-8 w-full ${bgStyles[background]} ${className}`} data-id="element-164" data-mp="35x1pj7blyly6">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.6,
      ease: 'easeOut'
    }} className="max-w-7xl mx-auto" data-id="element-165" data-mp="3ew5bcj25tfgd">
        {children}
      </motion.div>
    </section>;
}